import { render, staticRenderFns } from "./KycFile.vue?vue&type=template&id=f9413ffe"
import script from "./KycFile.vue?vue&type=script&lang=js"
export * from "./KycFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports